import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { AppService } from '../../../../../../core/services/app.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { Formation } from '../../data-access/formation';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormationService } from '../../data-access/formation.service';
import { AppConfigService } from '../../../../../../core/services/config.service';

interface SelectConfig {
  items$: BehaviorSubject<any[]>;
  selected: any[];
  loading: boolean;
  typeahead: Subject<string>;
  page: number;
  searchTerm: string;
}
type SelectKey = 'competences' | 'formations' | 'catalogue';

@Component({
  selector: 'app-initier-formations',
  templateUrl: './initier-formations.component.html',
  styleUrls: ['./initier-formations.component.scss']
})
export class InitierFormationsComponent implements OnInit {
  @Input() type: string;
  @Input() skills: any;
  @Input() view: any;
  public selectedFormationType = '';
  public selectedCompetence: any;
  public selectedFormationCatalogue: any;
  public entretien_id: any;
  public agent_id: any;
  public listFormations: any[];
  public listType: any = [];
  public listDomaine: any = [];
  public lieux: any = [];
  public errorMessage: string | null = null;
  public type_formation: any;
  public typeFiche: any;
  public domaine_formation: any;
  public eia_selected: any;
  public formationData: Formation = new Formation(null, null, null, null, null, null, null, null,
    null, null, null, '', null);
  public loading = false;
  public typeSauvegarde: string;
  public detailsFormations: any;
  public settingsFormationCatalogue: any;
  public settingsCompetence: any;
  public typeDataLoaded = false;
  public selectConfigs: Record<SelectKey, SelectConfig>;
  constructor(
    private storage: LocalStorageService,
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private formationService: FormationService,
    private loadingBar: LoadingBarService,
    private configService: AppConfigService,
    private _service: AppService) {
    this.selectConfigs = {
      catalogue: this.createSelectConfig(),
      competences: this.createSelectConfig(),
      formations: this.createSelectConfig()
    };
  }

  ngOnInit() {
    const url = window.location.href;
    const split_url = url.split('/');
    this.entretien_id = split_url[6];
    this.formationData.agent_id = split_url[7];
    this.typeSauvegarde = split_url[11];
    this.typeFiche = split_url[9];
    this.eia_selected = this.storage.retrieve('idCampagneEiaSelected');
    this.getDetailsFormation();
    this.getAllCatalogueFormations();
    this.getListLieux();
    this.settingsCompetence = {
      singleSelection: true,
      text: 'Sélectionner la compétence',
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout déselectionner',
      classes: 'myclass custom-class',
      labelKey: 'intitule_competence',
      enableSearchFilter: true,
      searchBy: ['intitule_competence'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune compétence disponible'
    };
    this.settingsFormationCatalogue = {
      singleSelection: true,
      text: 'Sélectionner la formation',
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout déselectionner',
      classes: 'myclass custom-class',
      labelKey: 'libelle',
      enableSearchFilter: true,
      searchBy: ['libelle'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune formation disponible'
    };
  }


  public getListLieux() {
    const sigle = this.configService.get('SIGLE');
    sigle === 'SIR' ? this.formationData.lieu = 'SIR' : this.formationData.lieu = 'SMB';
    if (sigle === 'SIR') {
      this.lieux = [
        { value: 'SIR', label: 'SIR' },
        { value: 'HORS SIR', label: 'HORS SIR' },
        { value: 'HORS CI', label: 'HORS CI' }
      ];
    } else if (sigle === 'SMB') {
      this.lieux = [
        { value: 'SMB', label: 'SMB' },
        { value: 'HORS SMB', label: 'HORS SMB' },
        { value: 'HORS CI', label: 'HORS CI' }
      ];
    }
  }

  private createSelectConfig(): SelectConfig {
    return {
      items$: new BehaviorSubject<any[]>([]),
      selected: [],
      loading: false,
      typeahead: new Subject<string>(),
      page: 1,
      searchTerm: ''
    };
  }

  getClass() {
    return this.type === 'bulk' ? 'col-md-3 mt-3' : 'col-md-3';
  }

  getSpecificClass() {
    return this.type === 'bulk' ? 'col-md-3 mt-3' : 'col-md-2';
  }

  isFormInvalid(): boolean {
    const data = this.formationData;
    return !data.priorite || !data.lieu ||
      !data.periode_souhaite || !data.periode_evaluation_poste_formation ||
      !data.motivation || !data.mesure_efficacite || !this.selectedFormationType;
  }

  onOpen(key: SelectKey) {
    const config = this.selectConfigs[key];
    if (config.items$.value.length === 0) {
      this.loadData(key);
    }
  }

  onScrollToEnd(key: SelectKey) {
    const config = this.selectConfigs[key];
    if (!config.loading) {
      this.loadMoreData(key);
    }
  }

  onSearch(event: { term: string, items: any[] }, key: SelectKey) {
    const config = this.selectConfigs[key];
    config.searchTerm = event.term; // Stockage du terme de recherche
    config.typeahead.next(event.term);
  }

  private loadMoreData(key: SelectKey) {
    const config = this.selectConfigs[key];
    config.page++;
    this.loadData(key);
  }

  private loadData(key: SelectKey) {
    const config = this.selectConfigs[key];
    config.loading = true;
    this.errorMessage = null;
    const params = this.getParams(key);
    const url = this.getUrl(key);

    this._service.postData(url, params).pipe(
      map(response => this.extractData(response)),
      map(items => items.map(item => ({
        ...item,
        label: `[${item?.code ?? item?.code_stage}] ${item?.libelle}`
      }))),
      catchError(error => this.handleError(error, key))
    ).subscribe((data: any[]) => {
        if (config.page === 1) {
          config.items$.next(data);
        } else {
          config.items$.next([...config.items$.value, ...data]);
        }
        config.loading = false;
      },
      (err) => { this.toastrService.error(err.error.message); }
    );
  }

  private getUrl(key: SelectKey): string {
    return `postes-competences/${key}/all`;
  }

  private extractData(response: any): any[] {
    if (response?.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    } else {
      console.error('API did not return data in expected format:', response);
      return [];
    }
  }

  private handleError(error: any, key: SelectKey): Observable<any[]> {
    console.error(`Error loading ${key} data`, error);
    const config = this.selectConfigs[key];
    config.loading = false;
    this.errorMessage = `Failed to load ${key} data. Please try again.`;
    config.items$.next([]);
    return of([]);
  }

  private getParams(key: SelectKey): any {
    const config = this.selectConfigs[key];
    if (key === 'competences') {
      return { 'campagne_id': this.storage.retrieve('idCampagneEiaSelected'), page: config.page };
    } else if (key === 'formations') {
      return {
        page: config.page,
        type: this.type_formation?.type_stage,
        domaine_formation_id: this.domaine_formation?.id,
        search: config.searchTerm
      };
    }
    return { page: config.page };
  }

  public onSelectPeriode(ev) {
    this.formationData.periode_souhaite = ev.target.value;
  }

  public onSelectBudget(ev) {
    this.formationData.budget = ev.target.value;
  }

  public onSelectLieu(ev) {
    this.formationData.lieu = ev.target.value;
  }

  public onSelectUrgence(ev) {
    this.formationData.priorite = ev.target.value;
  }

  public onSelectPeriodeEvaluation(ev) {
    this.formationData.periode_evaluation_poste_formation = ev.target.value;
  }

  onClearItem(type: 'type' | 'domaine') {
    if (type === 'type') {
      this.listDomaine = [];
      this.domaine_formation = null;
      this.selectConfigs['formations'].items$.next([]);
    } else if (type === 'domaine') {
      this.domaine_formation = null;
      this.loadData('formations');
    }
  }

  public onChangeItem(event: any, type: 'type' | 'domaine' | 'catalogue') {
    if (type === 'type') {
      this.getDomaine(event.value.type_stage);
      this.listDomaine = [];
      this.domaine_formation = null;
      this.selectConfigs['formations'].items$.next([]);
    } else if (type === 'domaine') {
      this.loadData('formations');
    } else if (type === 'catalogue') {
      this.formationData.catalogue_formation_id = event.id;
    }
  }

  private getDomaine(type_stage: string): void {
    this._service.postData(`gestion-evaluations/formations/catalogue/getDomaineFormationByType`, { 'type': type_stage })
      .subscribe({
        next: (response) => {
          this.listDomaine = response['data'];
        },
        error: (error) => {
          this.toastrService.error(error.error.message);
        }
      });
  }

  public onDropdownClick(type) {
    switch (type) {
      case 'type':
        if (!this.typeDataLoaded) {
          this._service.postData(`gestion-evaluations/formations/catalogue/getAllType`, {}).subscribe((res) => {
            this.listType = res['data'],
              this.listType.forEach(e => { e.label = e?.type_stage; });
            this.typeDataLoaded = true;
          });
        }
        break;
    }
  }

  public getDetailsFormation() {
    this.loadingBar.start();
    const data = {
      'agent_id' : this.formationData.agent_id,
      'formation_id': this.skills ? this.skills?.formation_id : this.storage.retrieve('idFormation'),
      'type': this.typeSauvegarde,
      'campagne_id': this.storage.retrieve('idCampagneEiaSelected'),
    };
    let url;
    this.skills ? url = 'gestion-evaluations/formations/details' : url = 'gestion-evaluations/formations/getDetailDemandeurBeneficiaire';
    this._service.postData(`${url}`, data)
      .subscribe({
        next: (res: any) => {
          this.detailsFormations = res?.data;
          if (this.detailsFormations && this.type === 'edit') {
            this.formationData.duree_souhaite = this.detailsFormations.duree_souhaite;
            this.formationData.mesure_efficacite = this.detailsFormations.mesure_efficacite;
            this.formationData.motivation = this.detailsFormations.motivation;
            this.formationData.priorite = this.detailsFormations.priorite;
            this.formationData.periode_souhaite = this.detailsFormations.periode_souhaite;
            this.formationData.lieu = this.detailsFormations.lieu;
            this.formationData.periode_evaluation_poste_formation = this.detailsFormations.periode_evaluation_poste_formation;
          }
          this.loadingBar.stop();
        },
        error: (error) => {
          this.toastrService.error(error.error.message);
        }
      });
  }

  public getAllCatalogueFormations() {
    this.loadingBar.start();
    this._service.postData(`gestion-evaluations/formations/catalogue/all`, {})
      .subscribe({
        next: (res: any) => {
          this.listFormations = res?.data?.data;
          this.loadingBar.stop();
        },
        error: (error) => {
          this.toastrService.error(error.error.message);
        }
      });
  }

  public saveFormation() {
    this.loadingBar.start();
    this.loading = true;
    const data = {
      'agent_id': parseInt(this.formationData.agent_id),
      'type_intitule_formation': this.selectedFormationType,
      'intitule_formation': this.formationData.intitule_formation,
      'campagne_id': this.eia_selected,
      'catalogue_formation_id': parseInt(this.formationData.catalogue_formation_id),
      'formation_id': parseInt(this.skills?.formation_id),
      'lieu': this.formationData.lieu,
      'budget': this.formationData.budget,
      'priorite': this.formationData.priorite,
      'duree_souhaite': parseInt(this.formationData.duree_souhaite),
      'periode_souhaite': this.formationData.periode_souhaite,
      'periode_evaluation_poste_formation': this.formationData.periode_evaluation_poste_formation,
      'motivation': this.formationData.motivation,
      'mesure_efficacite': this.formationData.mesure_efficacite,
      'competences': this.selectedCompetence?.map(competence => ({
        competence_id: competence?.id,
        code: competence?.code,
        libelle: competence?.libelle,
      })),
      'type': this.typeSauvegarde
    };
    let url;
    this.type === 'bulk' ? url = 'gestion-evaluations/formations/save' : url = 'gestion-evaluations/formations/save-formation-poste';
    this._service.postData(url, data)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.toastrService.success(res?.message);
            this.activeModal.close();
            if (this.type === 'bulk') {
              this.formationService.notifyAllFormations();
            } else {
              this.formationService.notifyAllSkills();
            }
          } else {
            this.toastrService.error(res?.message);
          }
          this.loading = false;
          this.loadingBar.stop();
        },
        (err) => {
          console.error(err);
          this.loading = false;
          this.toastrService.error(err.error.message);
          this.loadingBar.stop();
        }
      );
  }

}
